export const validateStrategyIdFormat = (id) => {
  if (!id || typeof id !== 'string') {
    return { isValid: false, error: 'Strategy ID must be a non-empty string' };
  }

  id = id.trim();

  if (id.length < 3 || id.length > 100) {
    return { isValid: false, error: 'Must be 3-100 characters' };
  }

  if (/^[_-]/.test(id)) {
    return { isValid: false, error: 'Cannot start with underscore or hyphen' };
  }

  if (!/^[a-zA-Z0-9_-]+$/.test(id)) {
    return { isValid: false, error: 'Only alphanumeric, underscore, hyphen allowed' };
  }

  return { isValid: true, error: '' };
};

export const checkDuplicateStrategyIds = (bulkId, subStrategies, excludeIdx = null) => {
  const subIds = subStrategies
    .map((s, i) => (i === excludeIdx ? null : s.strategy_id?.trim()))
    .filter(id => id);

  if (subIds.includes(bulkId?.trim())) {
    return { isDuplicate: true, message: 'Sub-strategy ID cannot match bulk strategy ID' };
  }

  const uniqueIds = new Set(subIds);
  if (uniqueIds.size !== subIds.length) {
    return { isDuplicate: true, message: 'Duplicate strategy IDs found' };
  }

  return { isDuplicate: false, message: '' };
};
